import React from "react"
import { StyleSheet, TouchableOpacity } from "react-native"
import Icon from "react-native-vector-icons/AntDesign"
import { WebView } from "react-native-webview"

import Base from "../../base"

function navHeader(navigation, headerTitle) {
  return {
    ...Base.constants.headerOptions(false, headerTitle),
    headerLeft: () => (
      <TouchableOpacity
        style={Base.styles.headerButton}
        onPress={() => navigation.goBack()}
      >
        <Icon name="arrowleft" size={24} color="white" />
      </TouchableOpacity>
    ),
  }
}

export default function WebViewScreen(props) {
  props.navigation.setOptions(
    navHeader(props.navigation, props.route.params.title),
  )
  return (
    <WebView style={styles.main} source={{ uri: props.route.params.url }} />
  )
}

const styles = StyleSheet.create({
  main: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Base.colours.appLightGrey,
  },
})
